import { apiFetch } from '@/api/client';
import type { AuthenticatedUser } from '@/types/user';

export const getAuthenticatedUser = (): Promise<AuthenticatedUser> => apiFetch('/open/v1/users/me');
